import moment from 'moment'
import axios from 'axios'

export default async () => {
  console.log('Step 1 - fetching mock team')
  const mockTeam = (await axios.get('https://timenow-api-dev.geshdo.com/admin/teams')).data
    .find(team => team.name === 'Avengers')

  if (!mockTeam) return console.log('no mockteam, stopping')

  console.log('Step 2 - fetching mock team members')
  const teamMembers = (await axios.get(`https://timenow-api-dev.geshdo.com/admin/teams/${mockTeam.id}/members`)).data
  console.log(teamMembers);

  console.log('Step 3 - get reportable dates')
  const endOfCurrentMonth = moment().endOf('month').format('YYYY-MM-DD')
  const startOfPreviousMonth = moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DD')

  const datesToAdd = []
  let currentDate = startOfPreviousMonth

  while (currentDate <= endOfCurrentMonth) {
    const weekday = moment(currentDate).format('dddd')
    if(weekday === "Sunday" || weekday === 'Saturday'){
      currentDate = moment(currentDate).add(1, 'day').format('YYYY-MM-DD')
      continue
    }
    datesToAdd.push(currentDate)
    currentDate = moment(currentDate).add(1, 'day').format('YYYY-MM-DD')
  }
  console.log(datesToAdd);

  console.log('Step 4 - add reports for each user on their tariffs')
  await Promise.all(
    teamMembers.map(async (member) => {
      const memberTariffId = (await axios.get(`https://timenow-api-dev.geshdo.com/admin/employees/${member.userId}/tariffs`)).data[0].id
      console.log(memberTariffId);
      await Promise.all(
        datesToAdd.map(async (date) => {
          const randomNumber = Math.floor(Math.random() * 10) + 11
          const randomReport = {
            from: `${date}T08:00:00.000Z`,
            to: `${date}T${randomNumber}:00:00.000Z`,
            tariffId: memberTariffId,
            comment: ''
          }
          await axios({
            url: 'https://timenow-api-dev.geshdo.com/reports',
            method: 'POST',
            data: randomReport,
            headers: {
              "userId": member.userId
            }
          })
        })
        
      )
      // try {
      //   await axios.delete(`https://timenow-api-dev.geshdo.com/admin/teams/${mockTeam.id}/members/${member.userId}`)
      //   console.log(`Removed ${member.firstName} from ${mockTeam.name}`)
      // } catch {
      //   console.error(`Failed to remove ${member.firstName} from ${mockTeam.name}`)
      // }
    })
  )
  console.log('All done! Dolla dolla bill yall')

};